import React, { useState, useEffect } from "react";
import { PageHeader } from "antd";
import { THREEDS_URL } from "../../config/config";
import axios from "axios";
import Cookies from "js-cookie";
import TxDetails from "./Details/TxDetails";
import ThreeDSDetails from "./Details/ThreeDSDetails";
import TxHistory from "./Details/TxHistory";


const Transaction = (props) => {
    const [data, setData] = useState({});
    const [currency, setCurrency] = useState(null);
    const [loading, setLoading] = useState(true);
    const txid = props.match.params.id;
    const { t } = props;

    useEffect(() => {
        getTransactionDetail();
    }, []); // eslint-disable-line

    const getTransactionDetail = async () => {        
        const api_url = THREEDS_URL + `/api/v1/3ds/transaction/${txid}/details`;
        const token = Cookies.get("threeds_token");
        setLoading(true);

        await axios
            .post(api_url, {}, { headers: { Authorization: "Bearer " + token } })
            .then(({ data }) => {
                setData(data);
                setCurrency(data ? data.details ? data.details.currency_code : null : null);
                setLoading(false);
            })
            .catch((error) => console.log(error));
    };

    return (
        <>
            <PageHeader className="site-page-header" title={t("contents.3dsecure.details") + " (" + txid + ")"}> </PageHeader>
            <TxDetails t={t} loading={loading} data={data ? data : null} />
            <TxHistory t={t} loading={loading} data={data ? data.tx : []} currency={currency} />
            <ThreeDSDetails t={t} loading={loading} data={data ? data : null} />
        </>
    );
};

export default Transaction;